import { z } from 'zod';

/**
 * @openapi
 * components:
 *   schemas:
 *     CreateAppAssignmentDto:
 *       type: object
 *       properties:
 *         isDisabled:
 *           type: boolean
 *           description: Whether the app is disabled
 *       required:
 *         - isDisabled
 */
export const updateAppAssignmentDto = z.object({});

export type UpdateAppAssignmentDto = z.infer<typeof updateAppAssignmentDto>;
